const base = {
  default: {
    backgroundColor: 'coolGrey.10',
    '&.hasBorder': {
      height: '1px',
      backgroundColor: 'coolGrey.10',
    }
  }
};

const press = {
  default: {
    backgroundColor: 'coolGrey.10',
    '&.hasBorder': {
      height: '10px',
      backgroundColor: 'coolGrey.10',
    }
  }
};

const border = {
  products: {
    chart: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default border;
